import React, { Component, Fragment } from 'react';
import moment from 'moment';
import _set from 'lodash/set';
import _get from 'lodash/get';

import TextField from 'material-ui/TextField';
import { TableRow, TableRowColumn } from 'material-ui/Table';
import RaisedButton from 'material-ui/RaisedButton';

import api from 'services';
import { getNormalErrors, showNotification } from 'helpers';

export default class Region extends Component {

  constructor(props) {
    super(props);

    this.state = {
      data: this.props.data,
      ts: this.props.ts,
      errors: {}
    }
  }

  static getDerivedStateFromProps(props, state) {

    if (props.ts !== state.ts) {
      return {
        data: props.data,
        ts: props.ts
      }
    }

    return null;
  }

  handleChange(changes = []) {

    function validateValue(value) {
      if (typeof value !== 'boolean') {
        let dots = 0;
        value = value
          .replace(/[^\d|\.|-]/, '')
          .replace(/\./g, function() { return dots++ > 0 ? '' : '.'; })
          .replace(/\-/g, function(match, str) { return str === 0 ? '-' : '' });
      }
      return value;
    }

    let data = JSON.parse(JSON.stringify(this.state.data));
    let errors = {};

    changes.forEach(v => {
      _set(data, v.key, validateValue(v.value));
      if (!v.noError) {
        errors[v.key] = v.value && typeof v.value !== 'boolean' && !isNaN(parseFloat(v.value)) ? '' : 'required'
      }
    })

    this.setState({
      data,
      errors: {
        ...this.state.errors,
        ...errors
      }
    })
  }

  save = async () => {
    let { data, errors } = this.state;

    if (
      Object.keys(errors).reduce((res, key) => {
        if (errors[key]) {
          res = true;
          return res;
        }
      }, false)
    ) {
      return showNotification('There is an error. Check out inputs', 'error');
    }

    let result = await api.fuel.updateOne(data);

    if (result.status === 200) {
      showNotification('Fuel has been updated');
      return await this.props.getFuelList()
    }

    showNotification(getNormalErrors(result).error, 'error')
  }

  render() {
    let { data, data: { fuel }, errors } = this.state;

    return (
      <TableRow style={{borderBottom: '4px solid rgb(224, 224, 224)'}}>
        <TableRowColumn style={{
          display: 'flex',
          justifyContent: 'flex-start',
          flexDirection: 'column',
          alignItems: 'flex-start',
          flexWrap: 'wrap'
        }}>
          <Fragment>
            <p style={{whiteSpace: 'pre-wrap'}}>{data.name || 'no name'}</p>
            <RaisedButton
              label='Update'
              primary
              onClick={() => this.save()}
              style={{ margin: '0 10px 0 25px', lineHeight: '25px', height: '25px' }}
              buttonStyle={{ lineHeight: '25px', height: '25px' }}
              labelStyle={{ fontSize: '11px' }}
            />
          </Fragment>
        </TableRowColumn>
        <TableRowColumn>
          <TextField
            value={fuel.ifo180 || ''}
            hintText='0'
            onChange={(e, value) => {
              this.handleChange([{key: `fuel.ifo180`, value}])
            }}
            fullWidth
            errorText={errors[`fuel.ifo180`] ? 'required' : ''}
          />
        </TableRowColumn>
        <TableRowColumn>
          <TextField
            value={fuel.ifo380 || ''}
            hintText='0'
            style={{ marginLeft: '10px'}}
            onChange={(e, value) => {
              this.handleChange([{key: `fuel.ifo380`, value}])
            }}
            fullWidth
            errorText={errors[`fuel.ifo380`] ? 'required' : ''}
          />
        </TableRowColumn>
        <TableRowColumn>
          <TextField
            value={fuel.mgo || ''}
            hintText='0'
            style={{ marginLeft: '10px'}}
            onChange={(e, value) => {
              this.handleChange([{key: `fuel.mgo`, value}])
            }}
            fullWidth
            errorText={errors[`fuel.mgo`] ? 'required' : ''}
          />
        </TableRowColumn>
        <TableRowColumn>
          <TextField
            value={fuel.vlsfo || ''}
            hintText='0'
            style={{ marginLeft: '10px'}}
            onChange={(e, value) => {
              this.handleChange([{key: `fuel.vlsfo`, value}])
            }}
            fullWidth
            errorText={errors[`fuel.vlsfo`] ? 'required' : ''}
          />
        </TableRowColumn>
        <TableRowColumn>
          <TextField
            value={fuel.ulsfo || ''}
            hintText='0'
            style={{ marginLeft: '10px'}}
            onChange={(e, value) => {
              this.handleChange([{key: `fuel.ulsfo`, value}])
            }}
            fullWidth
            errorText={errors[`fuel.ulsfo`] ? 'required' : ''}
          />
        </TableRowColumn>
        <TableRowColumn>
          <TextField
            value={fuel.lsmgo || ''}
            hintText='0'
            style={{ marginLeft: '10px'}}
            onChange={(e, value) => {
              this.handleChange([{key: `fuel.lsmgo`, value}])
            }}
            fullWidth
            errorText={errors[`fuel.lsmgo`] ? 'required' : ''}
          />
        </TableRowColumn>
        <TableRowColumn>
          <Fragment>
            <p>{moment(data.actualDate || new Date()).format('DD:MM:YYYY hh:mm')}</p>
          </Fragment>
        </TableRowColumn>
      </TableRow>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/Fuel/FuelEntity.js